export default {
  brewery: 'degarde',
  info_url: 'http://landing.tavour.com/degarde/',
  title: {
    in_progress: '',
    success: 'You have joined the Keepers Membership from de Garde Brewing!',
    subtext: 'Join the Keepers Membership from de Garde Brewing',
  },
  review: {
    summary: [
      'You are joining the Keepers Membership from de Garde Brewing where you will receive 6 delicious beers Biannually.',
      'By signing up, your credit card will automatically be charged $146 twice a year.',
      'You\'ll be able to purchase additional bottles prior to each shipment.',
      'You\'ll also have the opportunity to "opt out" before your card is charged by emailing keepers@degardebrewing.com or support@tavour.com',
      "You'll receive a notification when the box is charged along with tracking info when it ships.",
      'Cheers!',
    ],
    button_text: 'Join the Club!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/degarde.js